import { render, staticRenderFns } from "./EmplacementDetail.vue?vue&type=template&id=8dbe7fc0&"
import script from "./EmplacementDetail.vue?vue&type=script&lang=js&"
export * from "./EmplacementDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports